import Button from "@/common/components/Button"
import GoBackButton from "@/common/components/GoBackButton"
import Tabs from "@/common/components/Tabs"
import { useInternalRouterUtils } from "@/common/stores/internalRouter"
import { ChevronsRight } from "lucide-react"
import { Link, useParams } from "react-router-dom"
import GeneralDataTab from "./components/GeneralDataTab"
import IntegrationsTab from "./components/IntegrationsTab"
import useEquipmentModel from "../../hooks/useEquipmentModel"

const Show = () => {
  const { id } = useParams();
  const { getPreviousRoute } = useInternalRouterUtils();

  const {
    data: initialEquipment,
    isLoading,
    isPending,
    error: requestError = {} as any,
    refetch: refetchRequest,
  } = useEquipmentModel(id || '')

  const disableUpdateButton = isPending || requestError?.status === 403;

  const cameFromModelIntegrationCodes = getPreviousRoute()?.pathname.startsWith('/model-integration-codes')

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2 items-center">
          <GoBackButton
            fallback="/equipment-models"
            searchLastRouteFromFallback={!cameFromModelIntegrationCodes}
            searchLastRouteIgnoringFilters={cameFromModelIntegrationCodes}
          />
          <p className="text-white-400 font-normal">Modelos de equipamentos</p>
          <ChevronsRight color='#ffffffb3' />
          <h2>{initialEquipment?.display_name}</h2>
        </div>

        {!initialEquipment?.fipe_code &&
          <Link to={`/equipment-models/${id}/edit`}>
            <Button
              name="access_equipment_models_show"
              operationKlassToCheckPermission="Admin::EquipmentModels::Update"
              type="submit"
              className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]"
              disabled={disableUpdateButton}
            >
              Editar
            </Button>
          </Link>
        }

      </div>

      <Tabs
        tabsListClassName="w-full bg-transparent rounded-none"
        tabsTriggerClassName="h-8 w-full rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
        tabsContentClassName="mt-6"
        tabsList={[
          {
            value: '',
            label: 'Dados gerais',
            body: (
              <GeneralDataTab
                equipment={initialEquipment}
                isLoading={isLoading}
                requestError={requestError}
                refetchRequest={refetchRequest}
              />
            ),
          },
          {
            value: 'integrations',
            label: 'Integrações',
            operationKlassToCheckPermission: 'Admin::EquipmentModels::ModelIntegrationCodesFilter',
            body: <IntegrationsTab equipmentModelId={id || ''} />,
          },
        ]}
      />
    </div>
  )
}

export default Show
